(function () {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('ObservationDefinitionsController', ObservationDefinitionsController);

    ObservationDefinitionsController.$inject = ['ObservationDefinitions', 'FileUploadService', 'SoopkitchenUtils', '$scope'];

    function ObservationDefinitionsController(ObservationDefinitions, FileUploadService, SoopkitchenUtils, $scope) {
        var vm = this;

        /**** Properties ****/

        vm.isUploading = false;
        vm.ascending = false;
        vm.predicate = "timestamp";

        /**** Methods ****/

        vm.sortTable = sortTable;
        vm.uploadFiles = uploadFiles;
        vm.save = save;
        vm.formatIsoZuluDateString = SoopkitchenUtils.formatIsoZuluDateString;
        vm.openDeleteDialog = ObservationDefinitions.openDeleteDialog;

        // Load all Observation definitions.
        ObservationDefinitions.getObservationDefinitions(init, showError);

        function init(response) {
            vm.observationDefinitions = response.data;
            sortTable();
            // By default, sort by timestamp desc (SPKT-517)
        }
        
        function showError(response) {
            SoopkitchenUtils.prettyError(response, function () {
                $scope.$apply();
            });
        }
        
        function sortTable() {
            vm.observationDefinitions = SoopkitchenUtils.sort(vm.observationDefinitions, vm.predicate, !vm.ascending);
            $scope.$applyAsync();
        }
        
        function uploadFiles(files) {
            vm.files = files;
        }
        
        function successUpload(response) {
            SoopkitchenUtils.processResponse(
                response,
                "Observation Definitions Created", "An Observation Definitions  with name '"
                + vm.labelVal + "' has been created",
                function () {
                    location.reload();
                }
            );
        }

        function failureUpload(response) {
            SoopkitchenUtils.prettyError(response, function () {
                vm.isUploading = false;
                $scope.$apply();
            });
        }
        
        function save() {
            if (vm.files && vm.files.length) {
                vm.isUploading = true;
                ObservationDefinitions.uploadObservationDefinition(vm.labelVal, vm.files, vm.description, successUpload, failureUpload)
            }
        }

    }
})();
